/**
 * Formularz laureata — Figma 160:3355 / 160:3464, podziękowania 160:3285 /
 * 160:7697.
 *
 * Po udanej wysyłce podmieniamy ekran formularza na podziękowania — i TYLKO tu
 * one się pokazują. Przy późniejszym wejściu na ten sam adres serwer renderuje
 * komunikat „Formularz został już uzupełniony" (templates/index/winner.html.twig).
 * W wariancie instant win plansza losowania przechodzi wtedy w dekoracyjny
 * układ kolorów z makiety podziękowań.
 */

const MIXED_COLORS = ['red', 'yellow', 'accent', 'accent', 'accent', 'yellow', 'red', 'yellow', 'accent'];

$('.winner-form').on('submit-success', function (event, data, xhr) {
	event.assert(201 == xhr.status && 'OK' == data.status);

	const $section = $(this).closest('.s-winner');

	// Ekran podziękowań jest krótszy — plansza wraca wyżej, dolne maskotki znikają.
	$section.addClass('s-winner--sent');
	$section.find('[data-page]').addClass('d-none');
	$section.find('[data-page="thank-you"]').removeClass('d-none');

	$section.find('[data-draw]').addClass('c-draw--mixed')
		.find('[data-draw-tile]').each(function (index) {
			$(this)
				.removeClass('c-draw__tile--prize')
				.addClass(`c-draw__tile--${MIXED_COLORS[index]}`)
				.html('<span class="c-draw__eye" aria-hidden="true"></span>');
		});

	window.scrollTo({ top: 0, behavior: 'smooth' });
});

// „Nie posiadam numeru PESEL" (tylko nagroda tygodnia i główna): blokuje PESEL
// i odsłania obywatelstwo + datę urodzenia. Odsłanianie idzie przez `disabled`
// na wierszu, nie klasą — `fieldset:disabled { display: none }` (generic.scss)
// ukrywa pole i jednocześnie wyłącza jego walidację HTML5, więc niewidoczne
// wymagane pole nie zablokuje wysyłki. Serwer trzyma ten sam warunek
// w `_enabled_if` (config/packages/workflow.yaml).
$('[name="personal_data[noPesel]"]').on('change', function () {
	const checked = $(this).prop('checked');
	const $form = $(this.form ?? $(this).closest('form'));

	$form.find('[name="personal_data[pesel]"]').prop('disabled', checked);
	$form
		.find('[name="personal_data[citizenship]"], [name="personal_data[birthDay]"]')
		.closest('.form-group')
		.prop('disabled', !checked);
}).trigger('change');

$('.winner-form').on('submit-error', function (event, xhr) {
	// 410 stawia guard GuardTimeLimitSubscriber, gdy termin minął w trakcie
	// wypełniania formularza (albo gdy ktoś wrócił do starej, otwartej karty).
	if (410 == xhr.status) {
		event.preventDefault();
		alert($(this).data('expiredMessage'));
	}
});
